import React from 'react';
import {List, Datagrid, TextField, ReferenceField} from 'react-admin';
import {Filter, ReferenceInput, TextInput, SelectInput} from 'react-admin';
import { Fragment } from 'react';
import ButtonCreateJob from './ButtonCreateJob';

const HydrantFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="deviceId" alwaysOn />
    <ReferenceInput label="Firmware" source="firmwareId" reference="firmwares" allowEmpty>
        <SelectInput optionText="version" />
    </ReferenceInput>
  </Filter>
);

const PostBulkActionButtons = props => (
  <Fragment>
      <ButtonCreateJob {...props}/>
  </Fragment>
);

export const HydrantList = props => {
  return (
    <>
      <List title='Hydrant Fleet Management - Hydrants' 
        exporter={false} {...props}  
        // bulkActionButtons={false} 
        bulkActionButtons={<PostBulkActionButtons />} 
        filters={<HydrantFilter />}
      >
        <Datagrid>
          <TextField label="Device Id" source="id" />
          <ReferenceField label='Firmware' source='firmwareId' reference='firmwares'>
            <TextField source="version" />
          </ReferenceField>
          <TextField label="Device Tag"source="deviceTag" />
          <TextField label="Device Type" source="deviceType" />
          <TextField label="Status" source="status" />
          <TextField label="Longitude" source="longitude" />
          <TextField label="Latitude" source="latitude" />
        </Datagrid>
      </List>
    </>  
  );
};

  
  